import { TabContext, TabPanel } from '@mui/lab';
import { Tab, Tabs } from '@mui/material';
import React from 'react';

import administrator from '../../assets/images/administrator.jpg';
import clientRunner from '../../assets/images/client-runner.svg';
import practitionerOffice from '../../assets/images/practitioner-office.svg';

import SignUpTabsProps from './interfaces/signUpTabProps';
import SignUpCard from './SignUpCard';

const SignUpTabs: React.FC<SignUpTabsProps> = ({ handleTabChange }) => {
  // Always use practiceAdmin as the selected tab value
  const displayTabValue = 'practiceAdmin';

  return (
    <TabContext value={displayTabValue}>
      <Tabs
        value={displayTabValue}
        onChange={handleTabChange}
        aria-label="practitioner-client tabs"
        sx={{ pointerEvents: 'none' }} // Disable tab selection
        data-testid="signup-tabs"
      >
        <Tab
          label="Practice Administrator"
          value="practiceAdmin"
          data-testid="practice-admin-tab"
        />
        {/* Suppressed tabs but keeping references */}
      </Tabs>
      <TabPanel value="practiceAdmin" data-testid="practice-admin-panel">
        <SignUpCard
          image={administrator}
          alt="practice admin"
          title="Transform Lives Every Day!"
          description="Transform the lives of your patients, every day."
          data-testid="practice-admin-card"
        />
      </TabPanel>
      <TabPanel value="practitioner" data-testid="practitioner-panel">
        <SignUpCard
          image={practitionerOffice}
          alt="coaching environment"
          title="Embrace Personalized Coaching for Health & Wellness!"
          description="Discover personalized coaching for your well-being."
          data-testid="practitioner-card"
        />
      </TabPanel>
      <TabPanel value="client" data-testid="client-panel">
        <SignUpCard
          image={clientRunner}
          alt="wellness environment"
          title="Welcome to Your Wellness Journey!"
          description="Start your personalized wellness journey today."
          data-testid="client-card"
        />
      </TabPanel>
    </TabContext>
  );
};

export default SignUpTabs;
